import { render, staticRenderFns } from "./orderpayment.vue?vue&type=template&id=6f9528e0&scoped=true&"
import script from "./orderpayment.vue?vue&type=script&lang=js&"
export * from "./orderpayment.vue?vue&type=script&lang=js&"
import style0 from "./orderpayment.vue?vue&type=style&index=0&id=6f9528e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9528e0",
  null
  
)

export default component.exports